import {
  Box,
  Button,
  Card,
  Grid2,
  Typography,
  Alert,
  AlertTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { AppContext } from '../../../store/AppContext';
import { getFacilitiyV2, getReportsV2 } from '../../../helpers/api';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import PersonnelStatCards from './personnel/PersonnelStatCards';
import PersonnelFacilityQuarter from './personnel/PersonnelFacilityQuarter';

// Icons for the new UI elements
import {
  Science,
  ArrowForward,
  AssignmentLate,
  CheckCircleOutline,
  History,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import PersonnelAlert from './personnel/PersonnelAlert';
import PersonnelActivity from './personnel/PersonnelActivity';

const PersonelDashboardScreen = withRouter(({ props }) => {
  const { state } = useContext(AppContext);
  const { firstname, lastname, status } = state?.auth?.result?.data || {};

  const [facilityList, setFacilityList] = useState([]);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [facilityInitSelected, setFacilityInitSelected] = useState();

  const [resultList, setResultList] = useState([]);
  const [resultLoading, setResultLoading] = useState(false);

  // DUMMY STATE: Replace this with your actual logic to check if QAQC is ready
  const isQAQCReady = true;

  useEffect(() => {
    fetchFacilityList();
    fetchResultList();
  }, []);

  const fetchFacilityList = async () => {
    setFacilityLoading(true);
    try {
      const res = await getFacilitiyV2('', '', '', '', '', '', '', '', 1, 100);
      const { data, status } = res?.result || {};
      if (status?.code === '00') {
        setFacilityList(data);
        setFacilityInitSelected(data[0]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFacilityLoading(false);
    }
  };

  const fetchResultList = async () => {
    setResultLoading(true);
    try {
      const res = await getReportsV2('', '', '', '', '', '', 1, 100);
      const { data, status } = res?.result;
      if (status?.code === '00') setResultList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setResultLoading(false);
    }
  };

  return (
    // 1. FIXED BACKGROUND: minHeight '100vh' ensures the background never cuts off
    <Box sx={{ minHeight: '100vh', bgcolor: '#F4F6F8', p: { xs: 2, md: 4 }, mt: -1 }}>
      <Grid2 container spacing={3}>
        {/* Header Section */}
        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <Typography variant="h4" color="text.primary" fontWeight={700} gutterBottom>
            Welcome back, {firstname} 👋
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Here is what is happening across your facilities today.
          </Typography>
        </Grid2>

        {/* 2. QAQC ALERT BANNER */}
        {/* {isQAQCReady && (
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Alert
              severity="info"
              icon={<Science fontSize="inherit" />}
              action={
                <Button color="inherit" size="small" endIcon={<ArrowForward />}>
                  VIEW RESULTS
                </Button>
              }
              sx={{
                borderRadius: '16px',
                border: '1px solid',
                borderColor: 'info.light',
                bgcolor: alpha('#0288d1', 0.05), // Very soft blue background
                alignItems: 'center',
                boxShadow: '0px 4px 12px rgba(2, 136, 209, 0.05)',
              }}
            >
              <AlertTitle sx={{ fontWeight: 700, mb: 0.25 }}>QAQC Results Available</AlertTitle>
              The latest Quality Assurance / Quality Control results have been published for your
              primary facility.
            </Alert>
          </Grid2>
        )} */}

        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <PersonnelAlert resultList={resultList} resultLoading={resultLoading} />
        </Grid2>

        {/* Top Stat Cards */}
        <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
          <PersonnelStatCards facilityList={facilityList} facilityLoading={facilityLoading} />
        </Grid2>

        {/* Left Column: Monitoring Schedule */}
        <Grid2 size={{ lg: 7, md: 12, sm: 12, xs: 12 }}>
          {facilityLoading ? (
            <Box mt={2}>
              <LoaderSkeleton />
              <LoaderSkeleton />
            </Box>
          ) : facilityList?.length < 1 ? (
            <Card
              elevation={0}
              sx={{
                p: 4,
                borderRadius: '16px',
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="h6" color="textSecondary">
                It appears you belong to no facility. Please contact an admin.
              </Typography>
            </Card>
          ) : (
            <PersonnelFacilityQuarter
              facilityList={facilityList}
              facilityLoading={facilityLoading}
              initFacility={facilityInitSelected}
            />
          )}
        </Grid2>

        {/* Right Column: 3. NEW PENDING TASKS & ACTIVITY */}
        <Grid2 size={{ lg: 5, md: 12, sm: 12, xs: 12 }}>
          <PersonnelActivity resultList={resultList} resultLoading={resultLoading} />
          {/* <Card
            elevation={0}
            sx={{
              p: 3,
              borderRadius: '16px',
              border: '1px solid',
              borderColor: 'divider',
              height: '100%',
              bgcolor: '#ffffff',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.03)',
            }}
          >
            <Typography variant="h6" fontWeight={700} mb={2}>
              Action Items
            </Typography>
            <List disablePadding>
              <ListItem disableGutters>
                <ListItemIcon>
                  <AssignmentLate color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Submit Q3 Readings"
                  secondary="Facility Alpha • Due in 2 days"
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                  Start
                </Button>
              </ListItem>
              <Divider component="li" sx={{ my: 1 }} />
              <ListItem disableGutters>
                <ListItemIcon>
                  <CheckCircleOutline color="success" />
                </ListItemIcon>
                <ListItemText
                  primary="Review Audit Feedback"
                  secondary="Completed yesterday"
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                  View
                </Button>
              </ListItem>
            </List>

            <Typography variant="h6" fontWeight={700} mt={4} mb={2}>
              Recent Activity
            </Typography>
            <List disablePadding>
              <ListItem disableGutters>
                <ListItemIcon>
                  <History color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="You generated Q2 Report"
                  secondary="Oct 24, 2023 at 10:45 AM"
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <History color="action" />
                </ListItemIcon>
                <ListItemText
                  primary="Admin updated Sampling Points"
                  secondary="Oct 20, 2023 at 2:15 PM"
                />
              </ListItem>
            </List>
          </Card> */}
        </Grid2>
      </Grid2>
    </Box>
  );
});

export default PersonelDashboardScreen;
